import currency from 'currency.js';
import { DEFAULT_PRECISION } from '@/utils/produto-utils';

const getCurrency = value => currency(value, { precision: DEFAULT_PRECISION });

const calculateTotals = (produtos, totalTransporte, valuePath) => {
  if (!produtos?.length) {
    return totalTransporte || 0;
  }
  const totalProdutos = produtos
    .map(p => getCurrency(p[valuePath]).value)
    .reduce((acc, val) => acc.add(val), getCurrency(0));
  return totalProdutos.add(getCurrency(totalTransporte)).value;
};

const getProdutosSelecionados = carrinhos => carrinhos
  .flatMap(carrinho => carrinho.produtos
    .filter(p => p.$$selecionado)
    .map(p => ({
      ...p.respostaCotacaoProduto,
      totalConvertido: p.respostaCotacaoProduto.valorMoedaConvertido.total,
    })));

export const totalFornecedor = fornecedor => ({
  total: calculateTotals(
    getProdutosSelecionados(fornecedor.carrinhos),
    fornecedor.totalTransporte,
    'total',
  ),
  totalConvertido: calculateTotals(
    getProdutosSelecionados(fornecedor.carrinhos),
    fornecedor.totalTransporteConvertido,
    'totalConvertido',
  ),
});

export const totalCarrinho = carrinho => ({
  total: calculateTotals(
    getProdutosSelecionados([carrinho]),
    carrinho.frete?.totalTransporte,
    'total',
  ),
  totalConvertido: calculateTotals(
    getProdutosSelecionados([carrinho]),
    carrinho.frete?.totalTransporteConvertido,
    'totalConvertido',
  ),
});

export default { totalCarrinho, totalFornecedor };
